import type { BoxProps } from '@chakra-ui/react';
import { Image, type ImageProps, Box } from '@chakra-ui/react';
import type { Coin } from '@halo/wallet-app';
import { useWalletStore } from '@/wallet';

export interface CoinIconProps extends BoxProps {
  coin: Coin;
  iconProps?: ImageProps;
  showNetIcon?: boolean;
  netIconProps?: ImageProps;
}

export function CoinIcon({
  coin,
  showNetIcon,
  iconProps,
  netIconProps,
  ...props
}: CoinIconProps) {
  const { getNet } = useWalletStore();

  const netIcon = useMemo(() => {
    if (showNetIcon) {
      return getNet(coin.netId)?.logo;
    }
  }, [coin.netId, getNet, showNetIcon]);

  return (
    <Box position="relative" borderRadius="full" w="36px" h="36px" {...props}>
      <Image src={coin.logo} alt="" w="100%" h="100%" borderRadius="full" {...iconProps} />
      {showNetIcon && (
        <Image
          position="absolute"
          bottom="0"
          right="0"
          transform="translate(10%, 10%)"
          src={netIcon}
          alt=""
          w="16px"
          h="16px"
          borderRadius="full"
          border="1px solid white"
          {...netIconProps}
        />
      )}
    </Box>
  );
}
